<template>
  <div class="main">
    <!-- 内容展示 -->
    <div class="content">
      <card-recharge></card-recharge>
    </div>
    <!-- 安全信息 -->
    <p class="footer">
      <span></span> Secured by
      <a href="https://opayweb.com/">Opay</a>
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style>
.main {
  width: 100%;
  height: 100%;
  background-color: #eef4f8;
  font-family: PingFangSC;
}
.content {
  width: 654px; /*px*/
  margin: 0 auto;
  padding-bottom: 64px; /*px*/
}
.main .footer {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  display: flex;
  line-height: 64px; /*px*/
  text-align: center;
  justify-content: center;
  font-size: 28px; /*px*/
  color: #8497a4;
}
.main .footer span {
  display: inline-block;
  height: 48px; /*px*/
  width: 48px; /*px*/
  margin-top: 8px; /*px*/
  background: url(~@/assets/img/safe.png) left center no-repeat;
}
.main .footer a {
  color: #1dcf9f;
  padding-left: 10px;
  text-decoration: none;
}
</style>